// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y_LoF","fullView":"styles_fullView__1jBcb"};